export default "__VITE_ASSET__C3J8Eqvv__"